/**
 * @generated SignedSource<<fa93da5382572c9264350ed4dc15d8a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeFundIntroductionSection_pageSection$data = {
  readonly anchorName: string;
  readonly title: string;
  readonly titleImageBackgroundUrl: string;
  readonly titleImageUrl: string;
  readonly versions: ReadonlyArray<{
    readonly country: string;
    readonly link1: {
      readonly " $fragmentSpreads": FragmentRefs<"SimpleLink_simpleLink">;
    } | null | undefined;
    readonly link2: {
      readonly " $fragmentSpreads": FragmentRefs<"SimpleLink_simpleLink">;
    } | null | undefined;
    readonly quote: string | null | undefined;
    readonly subText: string | null | undefined;
    readonly subTitle: string | null | undefined;
    readonly text: string | null | undefined;
  }>;
  readonly " $fragmentType": "HomeFundIntroductionSection_pageSection";
};
export type HomeFundIntroductionSection_pageSection$key = {
  readonly " $data"?: HomeFundIntroductionSection_pageSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeFundIntroductionSection_pageSection">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "SimpleLink_simpleLink"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeFundIntroductionSection_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageBackgroundUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anchorName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HomeFundIntroductionForCountry",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quote",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SimpleLink",
          "kind": "LinkedField",
          "name": "link1",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SimpleLink",
          "kind": "LinkedField",
          "name": "link2",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomeFundIntroduction",
  "abstractKey": null
};
})();

(node as any).hash = "6faf7951932469821d4cf293dcdca8f3";

export default node;
